<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('New course')"></breadcrumbs>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
            <form-create-course></form-create-course>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


  import Breadcrumbs from "../../Layout/Breadcrumbs";
  import FormCreateCourse from "../../Forms/Course/FormCreateCourse";

  export default {
    metaInfo() {
      return {
        title: this.$i18n.t('Add course')
      }
    },
    components: {FormCreateCourse, Breadcrumbs},

  };
</script>
<style></style>
